import React from 'react'

export default function HeadingText() {
  return (
    <>    
        <div>
            <h1>Skyler Whitfield Live</h1>
            <h2>- Live Music Americana -<br />Rock, Folk,Outlaw Country, & Celtic</h2>
        </div>
    </>
  )
}
